<template>
<form ref="niceChkForm" name="form_chk" method="GET" v-show="false">
    <input type="hidden" name="m" value="checkplusSerivce">
    <input type="hidden" name="EncodeData" value="">
</form>
</template>

<script>
import { mapState } from 'vuex';
import { 
    setNiceResultInLocalStorage,
} from '../utils/nice';

export default {
    name: 'NicePopup',
    
    computed: {
        ...mapState({
            NICE_TYPE: state => state.codeDictionary.items.NICE_TYPE,
        }),
        routeName(){
            return this.$route.name;
        },
        routeQuery() {
            return this.$route.query;
        },
        niceChk(){
			return (this.routeName == 'Nice');
		},
		callbackChk() {
			return (this.routeName == 'NiceCallback');
		},  
    },

    created () {
        this.$store.state.header = false;
        this.$store.commit('START_LOADING')
    },

    mounted() {
        this.submit();
    },
    data() {
        return {
        }
    },
    methods: {
        submit(){
            if(this.niceChk) return this.checkplus();
            if(this.callbackChk) return this.callback();
            // return window.close();
        },

        checkplus() {
            this.$store.dispatch('GET_NICE_ENCODE_DATA')
            .then((data)=>{
                this.$refs.niceChkForm.EncodeData.value = data.content;
                this.$refs.niceChkForm.action = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
                this.$refs.niceChkForm.submit();
            })
            .catch((e)=> {
                this.apiCatch(e, ()=>{
                    window.close();
                })
            });
        },

        callback() {
            //callback 존재하지 않을경우
            console.log(this.routeQuery)
            if(!this.routeQuery.type) {
                this.$store.commit('OPEN_MODAL', {
                    content: '본인인증 실패 관리자에게 문의해주세요.',
                    btnOne: '확인',
                    btnOneSubmit: () => {
                        window.close();
                    }
                });
            }
            //성공
            else if(this.routeQuery.type == this.NICE_TYPE.JOIN_SUCCESS.id) {
                let niceResult = {
                    name: this.routeQuery.name,
                    phone: this.routeQuery.mobileNo,
                    gender: this.routeQuery.gender,
                }
                setNiceResultInLocalStorage(niceResult);
                window.close();
                return;
            }

            else if(this.routeQuery.type == this.NICE_TYPE.JOIN_FAIL.id) {

                this.$store.commit('OPEN_MODAL', {
                    content: this.routeQuery.message,
                    btnOne: '확인',
                    btnOneSubmit: () => {
                        window.close();
                    }
                });
                return;
            } 
        }

    },
}
</script>

<style lang="scss" scoped>

</style>